import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../core/services/user.service';
import { KeySlService } from '../services/key-sl.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private readonly userService: UserService,
    public router: Router,
    private readonly keySlService: KeySlService
  ) {}
  async canActivate() {
    let user = await this.userService.isUserAvailable();
    if (this.keySlService.currentApiKey === null)
      this.keySlService.getSocialLinksKeysAndSet();

    if (user) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
